import { ResourceAction, Rol } from '@src/types/common';

type PermissionCheckFunction = (action: ResourceAction) => boolean;

export const companyFilterPermission = (
  roleId: any,
  isMultiCountry: boolean,
  checkPermission: PermissionCheckFunction,
): boolean => {
  if (isMultiCountry && [Rol.BROKER, Rol.PRE_BROKER].includes(Number(roleId))) {
    return true;
  }

  return checkPermission(ResourceAction.USE_FILTER_COMPANIES);
};
